import PropTypes from 'prop-types'

import Icon from '../Icons'
import SnackbarPortal from '../../helpers/portals/SnackbarPortal'

// For some reason, it was impossible to target these elements with .scss file,
// So we need to use inline styles
const snackbarStyles = {
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: '0 0 3px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  gap: '12px',
  left: '40px',
  lineHeight: '20px',
  padding: '15px 19px',
  position: 'absolute',
  right: '40px',
  width: 'calc(100% - 80px)',
  zIndex: 100,
  animation: 'slideUp 0.3s ease-out forwards',
  opacity: 0,
  bottom: '0',
  pointerEvents: 'none',
}

const Snackbar = ({ isError, isOpen, message }) => {
  const successColor = '#548671'
  const errorColor = '#ce2c21'

  if (!isOpen) return null

  return (
    <SnackbarPortal>
      <div
        style={{
          ...snackbarStyles,
          background: isError ? '#fbf0f0' : '#f3f6f5',
          color: isError ? errorColor : successColor,
        }}
      >
        <Icon
          icon={isError ? 'cross' : 'checkmark'}
          viewBox={isError ? '0 0 20 20' : '0 0 30 30'}
          styles={{
            borderRadius: '100%',
            padding: '4px',
            fill: isError ? errorColor : successColor,
            height: isError ? '17px' : '20px',
            width: isError ? '17px' : '20px',
            outline: `1px solid ${isError ? errorColor : successColor}`,
          }}
        />
        {message}
      </div>
    </SnackbarPortal>
  )
}

Snackbar.propTypes = {
  isError: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool,
  message: PropTypes.string.isRequired,
}

export default Snackbar
